import type { ReactNode } from 'react';
import { Scene3D, type SceneKind } from '@/components/motion/Scene3D';

export function PageHeading({
  eyebrow,
  title,
  description,
  children,
  violet = false,
  kind = 'orbit',
}: {
  eyebrow: string;
  title: string;
  description: string;
  children?: ReactNode;
  violet?: boolean;
  kind?: SceneKind;
}) {
  return (
    <header className={`page-heading ${violet ? 'page-heading-violet' : ''}`}>
      <div className="page-heading-copy">
        <span className="eyebrow">
          <span className="eyebrow-line" />
          {eyebrow}
        </span>
        <h1>{title}</h1>
        <p>{description}</p>
        {children}
      </div>
      <Scene3D className="page-heading-scene" violet={violet} kind={kind} />
    </header>
  );
}
